export default __webpack_public_path__ + "static/media/angbao-bonus-mooncake.a5ceda6f.webp";